import React, { FC } from 'react';

import DetailedInfo from './DetailedInfo';
import ShortInfo from './ShortInfo';

type OfficeInfoProps = {
  office: OfficeTypeProps;
  service?: any;
  isDetailed: boolean;
  onBack: () => void;
  onServicesCatalogOpen: () => void;
  phone?: boolean;
};

const OfficeInfo: FC<OfficeInfoProps> = ({
  office,
  service = null,
  isDetailed,
  onBack,
  onServicesCatalogOpen,
  phone = false,
}) =>
  isDetailed ? (
    <DetailedInfo
      office={office}
      phone={phone}
      onServicesCatalogOpen={onServicesCatalogOpen}
    />
  ) : (
    <ShortInfo
      office={office}
      service={service}
      onBack={onBack}
      onServicesCatalogOpen={onServicesCatalogOpen}
    />
  );

export default OfficeInfo;
